import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_2: FaireProductEntity = {
  token: "catalog_prod_prod-2",
  type: "product",
  name: "Lumbar Pillow - Raggy Applique Celebrate",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 19.55,
  msrpDollars: 48.88,
  sku: "CO0002",
  caseSize: 6,
  material: "Ceramic",
  collectionToken: "col_confetti-cake",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 228,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-accents"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
